import { t as defaultT } from "../../../../i18n";

// 스마트폴 / 스마트큐브는 같은 테이블·같은 API 를 쓰지만 사용자에게는 다른 장비로
// 보여야 한다. 안내 문구도 실제 배선된 장치 이름으로 나가도록 deviceType 을 받는다.
// 문구는 호출 시점에 번역한다(모듈 로드 때 고정하면 언어 전환이 반영되지 않는다).
// 컴포넌트에서는 useT() 로 받은 t 를 세 번째 인자로 넘기면 언어 변경 시 함께 리렌더된다.
const DEVICE_LABEL_KEY = {
  POLE: "energy.device.POLE",
  CUBE: "energy.device.CUBE",
};

export const getEnergyStateMessage = (type, deviceType = "POLE", t = defaultT) => {
  const device = t(DEVICE_LABEL_KEY[deviceType] ?? DEVICE_LABEL_KEY.POLE);

  switch (type) {
    case "missing-identifier":
      return t("energy.state.missingIdentifier", { device });
    case "no-incoming-data":
      return t("energy.state.noIncomingData", { device });
    default:
      return null;
  }
};
